module.exports = __webpack_public_path__ + "static/media/48.36ece448.webp";